'use strict';


'kiwi public';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _create = require('babel-runtime/core-js/object/create');

var _create2 = _interopRequireDefault(_create);

var _state = require('@/libs/state');

var _state2 = _interopRequireDefault(_state);

var _NetworkProvider = require('@/libs/NetworkProvider');

var _NetworkProvider2 = _interopRequireDefault(_NetworkProvider);

var _GlobalApi = require('@/libs/GlobalApi');

var _GlobalApi2 = _interopRequireDefault(_GlobalApi);

var _StateBrowserNetwork = require('./StateBrowserNetwork');

var _StateBrowserNetwork2 = _interopRequireDefault(_StateBrowserNetwork);

var _AppSettings = require('./AppSettings');

var _AppSettings2 = _interopRequireDefault(_AppSettings);

var _BufferSettings = require('./BufferSettings');

var _BufferSettings2 = _interopRequireDefault(_BufferSettings);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var netProv = new _NetworkProvider2.default();

exports.default = {
    components: {
        BufferSettings: _BufferSettings2.default,
        StateBrowserNetwork: _StateBrowserNetwork2.default
    },
    props: ['networks', 'sidebarState'],
    data: function data() {
        return {
            is_usermenu_open: false,
            show_provided_networks: false,
            provided_networks: (0, _create2.default)(null),
            pluginUiElements: _GlobalApi2.default.singleton().stateBrowserPlugins
        };
    },
    computed: {
        userInitial: function userInitial() {
            var network = _state2.default.getActiveNetwork();
            var initial = 'U';
            if (network && network.nick) {
                initial = network.nick.charAt(0).toUpperCase();
            }
            return initial;
        },
        networkName: function networkName() {
            var network = _state2.default.getActiveNetwork();
            var name = 'No Network';
            if (network) {
                name = network.name;
            }
            return name;
        },

        isPersistingState: function isPersistingState() {
            return !!_state2.default.persistence;
        },
        isRestrictedServer: function isRestrictedServer() {
            return !!_state2.default.settings.restricted;
        },
        networksToShow: function networksToShow() {
            var bncNet = _state2.default.setting('bnc').network;
            return this.networks.filter(function (network) {
                return network !== bncNet;
            });
        },
        isConnected: function isConnected() {
            var network = _state2.default.getActiveNetwork();
            return network && network.state === 'connected';
        }
    },
    created: function created() {
        var _this = this;

        netProv.on('networks', function (networks) {
            _this.provided_networks = networks;
        });
    },
    methods: {
        clickAddNetwork: function clickAddNetwork() {
            var nick = 'Guest' + Math.floor(Math.random() * 100);
            var network = _state2.default.getNetworkFromAddress('');
            if (typeof network === 'undefined') {
                network = _state2.default.addNetwork('Network', nick, {});
            }
            network.showServerBuffer('settings');
        },
        clickAppSettings: function clickAppSettings() {
            _state2.default.$emit('active.component', _AppSettings2.default);
        },
        hideStatebrowser: function hideStatebrowser() {
            _state2.default.$emit('statebrowser.hide');
        },
        clickForget: function clickForget() {
            var msg = 'This will delete all stored networks and start fresh. Are you sure?';

            var confirmed = confirm(msg);
            if (!confirmed) {
                return;
            }

            _state2.default.persistence.forgetState();
            window.location.reload();
        },
        connectProvidedNetwork: function connectProvidedNetwork(pNet) {
            var net = _state2.default.addNetwork(pNet.name, pNet.nick, {
                server: pNet.server,
                port: pNet.port,
                tls: pNet.tls,
                password: pNet.password
            });

            net.ircClient.connect();
        }
    }
};
window._kiwi_exports = window._kiwi_exports || {};
if(!window._kiwi_exports["components"]) window._kiwi_exports["components"] = {};
window._kiwi_exports["components"]["StateBrowser"]
window._kiwi_exports.components.StateBrowser = exports.default ? exports.default : exports;



//////////////////
// WEBPACK FOOTER
// ./build/exports-loader.js!./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/StateBrowser.vue
// module id = Ta7/
// module chunks = 1